import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, AlertCircle, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

const LOGO = "https://customer-assets.emergentagent.com/job_261f6229-25c6-462a-bf7c-d1c15ef074eb/artifacts/vpvrvwp5_logo%20imagotip%20xpro%20blanco.png";

export default function AdminLogin() {
  const { admin, login, checked } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (!checked) return null;
  if (admin) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail) || "Error de conexión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10">
          <img src={LOGO} alt="XPRO Fitness" className="h-14 w-auto" />
        </div>

        <div className="border border-white/10 bg-[#0a0a0a] p-8 md:p-10">
          <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#FFCC00] mb-4">
            / Admin
          </div>
          <h1 className="font-display text-4xl text-white mb-8 leading-none">Accedeix al panell</h1>

          <form onSubmit={onSubmit} className="space-y-5">
            <label className="block">
              <span className="block text-[10px] tracking-[0.22em] uppercase font-bold text-white/60 mb-2">
                Email
              </span>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email"
                className="w-full bg-black border border-white/15 text-white placeholder:text-white/30 px-4 py-3 text-sm focus:outline-none focus:border-[#FFCC00]"
                placeholder="admin@xprofitness.cat"
              />
            </label>

            <label className="block">
              <span className="block text-[10px] tracking-[0.22em] uppercase font-bold text-white/60 mb-2">
                Contrasenya
              </span>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password"
                className="w-full bg-black border border-white/15 text-white px-4 py-3 text-sm focus:outline-none focus:border-[#FFCC00]"
                placeholder="••••••••"
              />
            </label>

            {error && (
              <div
                data-testid="admin-login-error"
                className="flex items-start gap-3 p-3 bg-red-500/10 border border-red-500/30 text-red-300 text-sm"
              >
                <AlertCircle size={16} className="shrink-0 mt-0.5" />
                <span>{error}</span>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full inline-flex items-center justify-center gap-3 px-6 py-4 bg-[#FFCC00] text-black font-bold text-xs tracking-[0.22em] uppercase hover:bg-white transition-colors disabled:opacity-50"
            >
              {loading ? (
                <>
                  <Loader2 size={16} className="animate-spin" />
                  Entrant...
                </>
              ) : (
                <>
                  Entrar
                  <ArrowRight size={16} />
                </>
              )}
            </button>
          </form>
        </div>

        <a href="/" className="block text-center text-xs text-white/40 hover:text-[#FFCC00] mt-6 tracking-[0.2em] uppercase" data-testid="admin-back-home">
          ← Tornar a la web
        </a>
      </div>
    </div>
  );
}
